<template>
  <div>
    <div v-cloak class="frame-content">
      <div>
        <div class="ContactBubble">
          <button
            class="ContactBubble__Bubble ContactBubble__Bubble--opened"
            id="website-widget-button"
            aria-label="Chat widget close"
            @click="clickChatBubble"
          >
            <div class="ContactBubble__IconContainer">
              <!-- ContactBubble__CloseSvg--opened - add if popup opens -->
              <div
                id="ContactBubble_Svg_id"
                :class="[
                  isChatOpened ? 'ContactBubble__CloseSvg--opened' : '',
                ]"
                class="ContactBubble__CloseSvg"
                v-if="isChatOpened"
              >
                <svg
                  width="18px"
                  height="17px"
                  viewBox="0 0 19 18"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="white"
                    fill-rule="evenodd"
                  >
                    <path
                      d="M9.5,6.95724708 L15.9393398,0.756401316 C16.5251263,0.192310672 17.4748737,0.192310672 18.0606602,0.756401316 C18.6464466,1.32049196 18.6464466,2.2350636 18.0606602,2.79915424 L11.6213203,9 L18.0606602,15.2008458 C18.6464466,15.7649364 18.6464466,16.679508 18.0606602,17.2435987 C17.4748737,17.8076893 16.5251263,17.8076893 15.9393398,17.2435987 L9.5,11.0427529 L3.06066017,17.2435987 C2.47487373,17.8076893 1.52512627,17.8076893 0.939339828,17.2435987 C0.353553391,16.679508 0.353553391,15.7649364 0.939339828,15.2008458 L7.37867966,9 L0.939339828,2.79915424 C0.353553391,2.2350636 0.353553391,1.32049196 0.939339828,0.756401316 C1.52512627,0.192310672 2.47487373,0.192310672 3.06066017,0.756401316 L9.5,6.95724708 Z"
                      id="path-77"
                    ></path>
                  </g>
                </svg>
              </div>
              <!-- ContactBubble__Icon--opened - add if popup opens -->
              <div
                id="ContactBubble_Icon_id"
                :class="[isChatOpened ? 'ContactBubble__Icon--opened' : '']"
                class="ContactBubble__Icon"
                v-if="!isChatOpened" 
              >
                <svg
                  width="26px"
                  height="23px"
                  viewBox="0 0 26 21"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  alt="Open Webchat"
                  style="margin: 0px 1px 3px 0px"
                >
                  <g
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="Settings-11-Copy"
                      transform="translate(-208.000000, -370.000000)"
                      fill="#E2E8F0"
                    >
                      <path
                        d="M218,370 L223.65,370 C229.172847,370 233.65,374.477153 233.65,380 L233.65,390.9 L218,390.9 C212.477153,390.9 208,386.422847 208,380.9 L208,380 C208,374.477153 212.477153,370 218,370 Z M214.65,375.7 L214.65,377.41 L226.321429,377.41 L226.321429,375.7 L214.65,375.7 Z M214.65,383.3 L214.65,385.01 L226.321429,385.01 L226.321429,383.3 L214.65,383.3 Z M214.65,379.5 L214.65,381.21 L227.95,381.21 L227.95,379.5 L214.65,379.5 Z"
                        id="button-2-icon-only"
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import "./ChatWidget.css";
export default {
  name: "ChatWidgetBuble",
  emits: ["chatClicked"],
  props: {
    isChatOpened: Boolean
  },
  methods: {
    clickChatBubble() {
      this.$emit("chatClicked");
    },
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
</style>
